import {useEffect, useId, useState} from "react";
import {Calendar, DayValue} from "@hassanmojab/react-modern-calendar-datepicker";
import {GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {NumberToPersianLetters} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AddEditTuitionReminderModal = (props:{active:boolean,studentId:string,remindDate:string,price:number,isReminded:boolean,isEdit:boolean,reminderId:number,onDone:any,closeHandler:any}) => {
    const [remindDate,setRemindDate] = useState<DayValue>(null);
    const [price,setPrice] = useState('');
    const [isReminded,setIsReminded] = useState(false);
    const ids = {
        price:useId(),
    };
    const [err,setErr] = useState({
        price:false,
    });
    useEffect(()=>{
        const isActive = props.active;
        const isEdit = props.isEdit;
        const _remindDate = props.remindDate;
        const _price = props.price;
        const _isReminded = props.isReminded;
        if(isActive){
            document.body.classList.add('body-no-scroll');
            setErr({
               price: false,
            });
            if(isEdit){
                setIsReminded(_isReminded);
                setPrice(_price.toString());
                const d = GregorianToPersian(_remindDate).split('-');
                setRemindDate({
                    year:parseInt(d[0]),
                    month:parseInt(d[1]),
                    day:parseInt(d[2]),
                });
            } else {
                const today = new Date();
                const g2 = GregorianToPersian(today).split('-');
                setRemindDate({
                    year: parseInt(g2[0]),
                    month: parseInt(g2[1]),
                    day: parseInt(g2[2]),
                });
                setIsReminded(false);
                setPrice('');
            }
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    },[props.active]);
    const saveChanges = () => {
        const isEdit = props.isEdit;
        const remindId = props.reminderId;
        const _price = price;
        const _isReminded = isReminded;
        const _remindDate = `${remindDate?.year}-${remindDate?.month}-${remindDate?.day}`;
        const studentId = props.studentId;
        if(_price === ''){
            setErr({price: true});
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/tuition/reminders/' + (isEdit ? 'edit':'add'),
            {
                id:remindId.toString(),
                price:_price,
                remindDate:PersianToGregorian(_remindDate),
                isReminded:_isReminded?'1':'0',
                studentId:studentId,
            },
            true,
            (d: {
                result:string,
                reason:string|undefined,
            })=>{
                HideProgressLoading();
                if(d.result!=='OK'){
                    if(d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                props.closeHandler();
                props.onDone();
                ShowSnackbar(
                    isEdit ? 'ویرایش یادآوری انجام شد.':'یادآوری جدید افزوده شد.',
                    'باشه',
                    5000,
                );
            },
            ()=>{
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active':'')} onClick={props.closeHandler}/>
            <div className={"web-modal web-modal-xl" + (props.active ? ' active':'')}>
                <div className="web-modal-header">
                    <div>
                        <b>{props.isEdit ? 'ویرایش یادآوری' : 'یادآوری جدید'}</b>
                    </div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="container">
                        <div className="add-student row">
                            <div className="col-md-6">
                                <label htmlFor={ids.price}>مبلغ پیشنهادی:</label>
                                <input type="number"
                                       step={1000}
                                       min={0}
                                       id={ids.price}
                                       value={price}
                                       className={"form-control" + (err.price ? ' is-invalid' : '')}
                                       onChange={e => {
                                           const t = e.currentTarget.value;
                                           setPrice(t);
                                           setErr(v => {
                                               let x = {...v};
                                               x.price = false;
                                               return x;
                                           })
                                       }}
                                />
                                {
                                    price !== '' ?
                                        <span style={{
                                            display: 'block',
                                            margin: '5px 0 0 0',
                                            fontWeight: 400,
                                            color: '#0a53be'
                                        }}>{NumberToPersianLetters(parseInt(price)) + " تومان"}</span> : null
                                }
                                <div className={"invalid-feedback " + (err.price ? 'd-block' : 'd-none')}>
                                    لطفا یک مبلغ وارد کنید.
                                </div>
                                <div style={{height: 20}}/>
                                <label>وضعیت یادآوری:</label>
                                <button className={"techaran-radio-box" + (isReminded ? ' active' : '')}
                                        onClick={() => setIsReminded(true)}>
                                    <div><i/></div>
                                    <span>یادآوری شده</span>
                                </button>
                                <button className={"techaran-radio-box" + (!isReminded ? ' active' : '')}
                                        onClick={() => setIsReminded(false)}>
                                    <div><i/></div>
                                    <span>در انتظار</span>
                                </button>
                                <div style={{height: 20}}/>
                            </div>
                            <div className="col-md-6">
                                <label>تاریخ یادآوری:</label>
                                <Calendar
                                    value={remindDate}
                                    onChange={e => setRemindDate(e)}
                                    shouldHighlightWeekends
                                    colorPrimary='#0a53be'
                                    locale='fa'
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-end align-items-center"
                             style={{gap: 20, marginTop: 30}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره تغییرات</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};